<template>
  <vue-kityminder
      style="height: calc(100vh - 99px)"
      ref="kityminder"
      theme="fresh-blue"
      template="filetree"
      :toolbar-status="toolbar"
      @content-change="handleContent"
      @node-change="handleNode"
      @node-remove="handleRemove"
      @selection-change="handleSelection"
  >
  </vue-kityminder>
</template>

<script>
export default {
  name: 'CareerPath',
  data() {
    return {
      toolbar: {
        appendSiblingNode: false,
        appendChildNode: false,
        arrangeUp: false,
        arrangeDown: false,
        removeNode: false,
        text: false,
        template: true,
        hand: false,
        theme: false,
        resetLayout: false,
        zoomIn: true,
      }
    }
  },
  methods: {
    handleContent(data) {
      // console.log(data);
    },
    handleNode(data) {
      // console.log(data);

      if (data.id === 0) {
        this.$refs.kityminder.setNodeData('id', 12138);
      }
    },
    handleRemove(data) {
      // console.log(data);
    },
    handleSelection(data) {
      // console.log(data);
    }
  }
}
</script>
